module.exports = __webpack_public_path__ + "img/logo.fcf77177.svg";